import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { CreateButton } from "@/components/admin/create-button";
import { NumberField } from "@/components/admin/number-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { TopToolbar } from "../../layout/TopToolbar";
import type { Transfer } from "../../types";

export const TransferList = () => (
  <List
    sort={{ field: "occurred_at", order: "DESC" }}
    actions={<TransferActions />}
    pagination={<ListPagination rowsPerPageOptions={[25, 50, 100]} />}
  >
    <DataTable<Transfer> rowClick="show">
      <DataTable.Col source="occurred_at" field={DateField} />
      <DataTable.Col source="from_account_id">
        <ReferenceField
          source="from_account_id"
          reference="accounts"
          link={false}
        />
      </DataTable.Col>
      <DataTable.Col source="to_account_id">
        <ReferenceField
          source="to_account_id"
          reference="accounts"
          link={false}
        />
      </DataTable.Col>
      <DataTable.Col source="amount">
        <NumberField source="amount" />
      </DataTable.Col>
      <DataTable.Col source="description" />
    </DataTable>
  </List>
);

const TransferActions = () => (
  <TopToolbar>
    <CreateButton label="resources.transfers.action.new" />
  </TopToolbar>
);
